import customAxios from "./axiosConfig";

const BankService = {
  retrieve (account_id) {
    const api_url = window.Urls['bankaccount-detail'](account_id);
    return customAxios.get(api_url)
  },
  update (account_id, data) {
    const api_url = window.Urls['bankaccount-detail'](account_id);
    return customAxios.patch(api_url, data)
  },
  list (params) {
    const api_url = window.Urls['bankaccount-list']();
    return customAxios.get(api_url, { params: params })
  },
  getYears (params) {
    const api_url = window.Urls['v3:banktransaction-years']();
    return customAxios.get(api_url, { params: params })
  },
  destroy (account_id) {
    const api_url = window.Urls['bankaccount-detail'](account_id)
    return customAxios.delete(api_url)
  },
  grantUnifiedpostConsent(data) {
    const api_url = window.Urls['banks:unifiedpost_establish_consent']();
    return customAxios.post(api_url, data);
  },
  requestRefreshAccountMovements(params) {
    const api_url = window.Urls['banks:unifiedpost_request_refresh_account_movements']();
    return customAxios.get(api_url, { params: params });
  },
  getBankLogo(params) {
    const api_url = window.Urls['banks:unifiedpost_bank_logo']();
    return customAxios.get(api_url, { params: params });
  },
  getBankAccountStatus(id) {
    const api_url = window.Urls['bankaccount_status'](id);
    return customAxios.get(api_url);
  }
};

export default BankService;